"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FFS_EMAIL_ADDRESS = exports.CONFIGURATION_PRD = exports.CONFIGURATION_NONPRD = exports.CONTRACT_MANAGER_PRD = exports.CONTRACT_MANAGER_NONPRD = exports.PRICING_TERM_PRD = exports.PRICING_TERM_NONPRD = void 0;
var PRICING_TERM_NONPRD = 'https://stg-pricingterm.financialflows.cimpress.io';
exports.PRICING_TERM_NONPRD = PRICING_TERM_NONPRD;
var PRICING_TERM_PRD = 'https://pricingterm.financialflows.cimpress.io';
exports.PRICING_TERM_PRD = PRICING_TERM_PRD;
var CONTRACT_MANAGER_NONPRD = 'https://stg-contractmanager.ff.cimpress.io';
exports.CONTRACT_MANAGER_NONPRD = CONTRACT_MANAGER_NONPRD;
var CONTRACT_MANAGER_PRD = 'https://contractmanager.ff.cimpress.io';
exports.CONTRACT_MANAGER_PRD = CONTRACT_MANAGER_PRD;
var CONFIGURATION_NONPRD = 'https://stg-contractconfiguration.financialflows.cimpress.io';
exports.CONFIGURATION_NONPRD = CONFIGURATION_NONPRD;
var CONFIGURATION_PRD = 'https://contractconfiguration.financialflows.cimpress.io';
exports.CONFIGURATION_PRD = CONFIGURATION_PRD;
var FFS_EMAIL_ADDRESS = 'FinancialFlowsSupport@cimpress.com';
exports.FFS_EMAIL_ADDRESS = FFS_EMAIL_ADDRESS;